// ============================================================================
// CURRENCY SERVICE
// ============================================================================
// Read-only lookups over org.tbl_currency via /api/v1/common/currencies.
// Used by any screen that needs a currency picker — the authoritative
// currency master lives in the tenant DB, not in a frontend constants file.

import { get } from '../client/axiosClient';
import { currencyEndpoints } from '../endpoints/currency.endpoints';
import type { ApiResponse } from '../types';
import type { CurrencyDto } from '../types/currency.types';

class CurrencyService {
  /** Fetch all currencies. Optional search-term matches code or name. */
  async getAll(searchTerm?: string): Promise<CurrencyDto[]> {
    const response = await get<ApiResponse<CurrencyDto[]>>(
      currencyEndpoints.list(searchTerm),
    );
    return response.data.data ?? [];
  }
}

export const currencyService = new CurrencyService();
export default currencyService;
